export default __webpack_public_path__ + "static/media/Series-9100-MP-Inline-Remote-FAT.f9877b38.png";